import styled from 'styled-components';
import mainColors from '../../../Style-guide/main-colors';

const SelectCourtWrapper = styled.main`
  padding: 20px;

  .cards-container {
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
    margin: 40px auto;
  }

  .court-link {
    display: contents;
  }

  .choose-court-title {
    box-shadow: 0px 0px 13px 3px ${mainColors.main_color};
    text-align: center;
    padding: 16px 0;
  }
`;

export default SelectCourtWrapper;
